import { compose, withProps } from 'recompose';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import { selectors as settingSelectors } from 'state/settings';
import { selectors as orderSelectors } from 'state/order';
import { selectors as shipmentSelectors } from 'state/shipments';

import AditionalOptions from 'components/summary/AditionalOptions/component';

const enhance = compose(
  withTranslation('Summary'),
  connect((state, { shipmentKey }) => {
    const orderType = orderSelectors.getTypeOfOrder(state);

    return {
      orderType,
      features: settingSelectors.getFeatures(state),
      isEditing: orderSelectors.getIsEditing(state),
      hasAppointment: shipmentSelectors.getHasAppointment(state, shipmentKey),
    };
  }, {}),
  withProps(({ features: { insurance } }) => ({
    insurance,
  }))
);

export default enhance(AditionalOptions);
